@if(downloadIssueId()) {
<div class="tw-mx-auto tw-flex tw-max-w-xl tw-flex-col tw-items-center tw-gap-4 tw-p-8 tw-text-center">
  @if(downloadStatus() === 'loading') {
  <mat-spinner diameter="32"></mat-spinner>
  <div>Preparing the debug file…</div>
  } @else if(downloadStatus() === 'downloaded') {
  <div class="uw-message uw-message-success tw-w-full">The debug file download has started.</div>
  } @else {
  <div class="uw-message uw-message-danger tw-w-full">{{ downloadErrorMessage() }}</div>
  }
</div>
} @else {
@if(softphone()) {
<button mat-icon-button class="btn-warning" type="button" (click)="openReportIssueDialog(reportIssueDialog)"
  aria-label="Report soft phone issue" matTooltip="Report soft phone issue">
  <mat-icon>bug_report</mat-icon>
</button>
} @else {
<mat-icon class="text-warning tw-cursor-pointer hover:text-info" [inline]="true"
  (click)="openReportIssueDialog(reportIssueDialog)" matTooltip="Report an issue" matRipple>bug_report</mat-icon>
}

<ng-template #reportIssueDialog>
  <div class="tw-flex tw-items-center">
    <div mat-dialog-title>{{ softphone() ? 'Report soft phone issue' : 'Report Issue' }}</div>
    <button mat-icon-button mat-dialog-close class="tw-ms-auto tw-me-2" [disabled]="loading" aria-label="Close report dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    @if(loading){
      <mat-progress-bar mode="indeterminate" class="uw-progress-bar uw-progress-bar-top"></mat-progress-bar>
    }
    
    <div class="uw-fields-container tw-max-w-prose lg:tw-min-w-96">
      <mat-form-field>
        <mat-label>{{ softphone() ? 'What happened?' : 'Describe the issue' }}</mat-label>
        <textarea matInput rows="5" name="description" [(ngModel)]="issue.description"
          [attr.maxlength]="softphone() ? 2000 : null" [required]="softphone()"
          [placeholder]="softphone() ? 'What were you trying to do, and what went wrong?' : ''"></textarea>
      </mat-form-field>
      @if(softphone()) {
      <div class="tg-sm text-muted">Technical details, recent call-quality samples, and whole-call summaries will be included automatically and can only be downloaded by authorized support staff.</div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close [disabled]="loading">Cancel</button>
    <button mat-flat-button (click)="submitIssue()" [disabled]="loading || (softphone() && !issue.description?.trim())">
      {{ loading ? 'Sending report…' : (softphone() ? 'Send report' : 'Submit') }}
    </button>
  </mat-dialog-actions>
</ng-template>
}
